/**
 * Tippy's default round arrow (16×6). Symmetric in X; after svg-arrow.css rotate(180deg)
 * on [data-placement^=top] it points down at the reference center.
 */
export const TIPPY_ROUND_ARROW_SVG =
  '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></path></svg>';
